export const PersonType = {
  All: 'All',
  Physical: 'Physical',
  Juridical: 'Juridical'
}

export function getPersonTypeName(type) {
  switch(type) {
    case PersonType.All:
      return 'Account';
    case PersonType.Physical:
      return 'Physical'
    case PersonType.Juridical:
      return 'Juridical'
  }
}